import { UserbotBatches } from "../interfaces"
import { StatusChipColor } from "./statusChips"

/** Интервал опроса GET /account-batches/:id (спека §5.2). */
export const BATCH_POLL_MS = 3000

export const isAccountBatchTerminal = (
  status: UserbotBatches.AccountBatchJobStatus,
): boolean => ["completed", "failed", "cancelled"].includes(status)

/** «running» — info (progress-цвет MUI); терминальные — по статусу. */
export const BATCH_JOB_STATUS_META: Record<
  UserbotBatches.AccountBatchJobStatus,
  { label: string; color: StatusChipColor }
> = {
  running: { label: "Запущена", color: "info" },
  completed: { label: "Завершена", color: "success" },
  failed: { label: "Провалена", color: "error" },
  cancelled: { label: "Отменена", color: "default" },
}

export const BATCH_ITEM_STATUS_META: Record<
  UserbotBatches.AccountBatchItemStatus,
  { label: string; color: StatusChipColor }
> = {
  pending: { label: "Ожидает", color: "default" },
  dispatched: { label: "Цепочка запущена", color: "info" },
  succeeded: { label: "Успешно", color: "success" },
  failed: { label: "Ошибка", color: "error" },
  skipped: { label: "Пропущен", color: "warning" },
  cancelled: { label: "Отменён", color: "default" },
}
